import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, MenuItem, InputAdornment, IconButton } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AlertMsg from "../../../shared/components/AlertMsg";

interface UserDialogProps {  
  userData?: any;
  handleClose: () => void;
  handleSubmit: (userData:any) => void;  
}

export default function EditUser(props: UserDialogProps) {
  const { userData, handleSubmit, handleClose } = props;
  const [isEdited, setIsEdited] = useState(false);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (userData) {
      setUserName(userData.name || "");
      setUserEmail(userData.email || "");
      setUsername(userData.username || "");
      setPassword(userData.plain_password || "");
      setRole(userData.role);
    }
  }, [userData]);

  const handleCloseTask = () => {
    handleClose();
  };

  const submitClick = async () => {
    userData.name = userName;
    userData.email = userEmail;
    userData.username = username;
    userData.password = password;
    userData.role = role;
    handleSubmit(userData);
  };

  return (
    <div>
      <AlertMsg
        isOpen={isEdited}
        handleClose={() => setIsEdited(false)}
        message={`All clients in stage "${userName}" will be assigned to stage "${userName}"`}
        severity="warning"
      />
      <Dialog open={true} onClose={handleCloseTask}
        sx={{ '& .MuiDialog-paper': { width: '80%' } }}
        maxWidth="xs">
        <DialogTitle> Enter user details </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ mr: 2 }}>
            <FormControl variant="standard" sx={{ p: 0.5 }} fullWidth>
              <TextField
                margin="dense"
                id="name"
                label="Name"
                type="text"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                fullWidth
                variant="standard"
                size="small"
              />
            </FormControl>
          </Box>
          <Box sx={{ mr: 2 }}>
            <FormControl variant="standard" sx={{ p: 1 }} fullWidth>
              <TextField
                margin="dense"
                id="email"
                label="Email"
                type="email"
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                fullWidth
                variant="standard"
                size="small"
              />
            </FormControl>
          </Box>
          <Box sx={{ mr: 2 }}>
            <FormControl variant="standard" sx={{ p: 1 }} fullWidth>
              <TextField
                margin="dense"
                id="username"
                label="Username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                fullWidth
                variant="standard"
                size="small"
              />
            </FormControl>
          </Box>
          <Box sx={{ mr: 2 }}>
            <FormControl variant="standard" sx={{ p: 1 }} fullWidth>
              <TextField
                margin="dense"
                id="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                variant="standard"
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </FormControl>
          </Box>
          <Box sx={{ mr: 2 }}>
            <FormControl variant="standard" sx={{ p: 1 }} fullWidth>
              <TextField
                select
                margin="dense"
                id="role"
                label="Role"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                fullWidth
                variant="standard"
                size="small"
              >
                <MenuItem value="Auditor">Auditor</MenuItem>
                <MenuItem value="Admin">Admin</MenuItem>
              </TextField>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTask}>Cancel</Button>
          <Button onClick={submitClick}>Submit</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
